import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { authService } from '../services/api';

export default function Registro() {
  const navigate = useNavigate();
  const [form, setForm] = useState({ nombre: '', email: '', password: '', confirmar: '' });
  const [aceptaTyC, setAceptaTyC] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [exito, setExito] = useState(false);

  const handleChange = (e) => setForm(f => ({ ...f, [e.target.name]: e.target.value }));

  const validar = () => {
    if (!form.nombre.trim()) return 'El nombre es obligatorio';
    if (!form.email.trim()) return 'El email es obligatorio';
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email)) return 'El email no es válido';
    if (form.password.length < 8) return 'La contraseña debe tener al menos 8 caracteres';
    if (!/(?=.*[a-zA-Z])(?=.*\d)/.test(form.password)) return 'La contraseña debe tener letras y números';
    if (form.password !== form.confirmar) return 'Las contraseñas no coinciden';
    if (!aceptaTyC) return 'Debés aceptar los Términos y Condiciones';
    return null;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const err = validar();
    if (err) { setError(err); return; }

    setLoading(true);
    setError('');
    try {
      await authService.register(form.nombre.trim(), form.email.trim(), form.password);
      setExito(true);
    } catch (err) {
      setError(err.message || 'Error al crear la cuenta. Intentá de nuevo.');
    } finally {
      setLoading(false);
    }
  };

  if (exito) {
    return (
      <div className="min-h-screen bg-gray-950 flex items-center justify-center p-4">
        <div className="bg-gray-900 border border-gray-700 rounded-2xl p-10 max-w-md w-full text-center">
          <div className="text-5xl mb-4">📬</div>
          <h2 className="text-2xl font-bold text-white mb-3">¡Revisá tu email!</h2>
          <p className="text-gray-400 mb-2">
            Te enviamos un link de verificación a <span className="text-white font-medium">{form.email}</span>.
          </p>
          <p className="text-gray-500 text-sm mb-8">
            Hacé clic en el link del email para activar tu cuenta. Si no lo ves, revisá la carpeta de spam.
          </p>
          <button
            onClick={() => navigate('/app')}
            className="w-full bg-[#ed6f28] hover:bg-[#c45e1e] text-white font-semibold py-3 rounded-xl transition-colors"
          >
            Ir al inicio de sesión
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-950 flex items-center justify-center p-4">
      <div className="w-full max-w-md">

        {/* Logo */}
        <div className="text-center mb-8">
          <button onClick={() => navigate('/')}>
            <img
              src="/logorentiacompletonaranjablanco.png"
              alt="Rentia"
              className="h-12 w-auto object-contain mx-auto"
            />
          </button>
        </div>

        <div className="bg-gray-900 border border-gray-700 rounded-2xl p-8 shadow-xl">
          <h1 className="text-2xl font-bold text-white mb-1">Crear cuenta gratuita</h1>
          <p className="text-gray-400 text-sm mb-6">14 días de prueba sin tarjeta de crédito</p>

          {error && (
            <div className="mb-4 bg-red-900/40 border border-red-500 text-red-300 rounded-lg px-4 py-3 text-sm">
              {error}
            </div>
          )}

          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="text-gray-300 text-sm block mb-1.5">Nombre completo</label>
              <input
                name="nombre"
                value={form.nombre}
                onChange={handleChange}
                placeholder="Juan García"
                disabled={loading}
                className="w-full bg-gray-800 border border-gray-600 text-white rounded-lg px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-[#ed6f28] placeholder-gray-500 disabled:opacity-50"
              />
            </div>

            <div>
              <label className="text-gray-300 text-sm block mb-1.5">Email</label>
              <input
                name="email"
                type="email"
                value={form.email}
                onChange={handleChange}
                placeholder="juan@inmobiliaria.com"
                disabled={loading}
                className="w-full bg-gray-800 border border-gray-600 text-white rounded-lg px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-[#ed6f28] placeholder-gray-500 disabled:opacity-50"
              />
            </div>

            <div>
              <label className="text-gray-300 text-sm block mb-1.5">Contraseña</label>
              <input
                name="password"
                type="password"
                value={form.password}
                onChange={handleChange}
                placeholder="Mínimo 8 caracteres con letras y números"
                disabled={loading}
                className="w-full bg-gray-800 border border-gray-600 text-white rounded-lg px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-[#ed6f28] placeholder-gray-500 disabled:opacity-50"
              />
            </div>

            <div>
              <label className="text-gray-300 text-sm block mb-1.5">Confirmar contraseña</label>
              <input
                name="confirmar"
                type="password"
                value={form.confirmar}
                onChange={handleChange}
                placeholder="Repetí la contraseña"
                disabled={loading}
                className="w-full bg-gray-800 border border-gray-600 text-white rounded-lg px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-[#ed6f28] placeholder-gray-500 disabled:opacity-50"
              />
            </div>

            <label className="flex items-start gap-3 cursor-pointer">
              <input
                type="checkbox"
                checked={aceptaTyC}
                onChange={e => setAceptaTyC(e.target.checked)}
                disabled={loading}
                className="mt-0.5 accent-[#ed6f28]"
              />
              <span className="text-gray-400 text-sm">
                Acepto los{' '}
                <a href="/terminos" target="_blank" className="text-[#ed6f28] hover:underline">Términos y Condiciones</a>
                {' '}y la{' '}
                <a href="/privacidad" target="_blank" className="text-[#ed6f28] hover:underline">Política de Privacidad</a>
              </span>
            </label>

            <button
              type="submit"
              disabled={loading}
              className="w-full bg-[#ed6f28] hover:bg-[#c45e1e] text-white font-semibold py-3 rounded-xl transition-colors disabled:opacity-50 disabled:cursor-not-allowed mt-2"
            >
              {loading ? 'Creando cuenta...' : 'Crear cuenta gratuita'}
            </button>
          </form>

          <p className="text-center text-gray-500 text-sm mt-6">
            ¿Ya tenés cuenta?{' '}
            <button onClick={() => navigate('/app')} className="text-[#ed6f28] hover:underline">
              Iniciar sesión
            </button>
          </p>
        </div>
      </div>
    </div>
  );
}
